import { useState, useEffect } from "react";

const debounce = (func: Function, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  return [
    (...args: any[]) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    },
    () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    },
  ];
};

export function useDebounce<T>(value: T, delay = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const [handler, cancel] = debounce(() => {
      setDebouncedValue(value);
    }, delay);

    handler();

    return () => {
      cancel();
    };
  }, [value, delay]);

  return debouncedValue;
}
